import React, { useRef } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider, createTheme, CssBaseline } from "@mui/material";
import About from "../src/components/About/About";
import HeroSection from "../src/components/HeroSection/HeroSection";
import Header from "../src/components/Header/Header";
import Services from "./components/Services/Services";
import Contact from "./components/Contact/Contact";
import Companies from "./components/Companies/Companies";

function App() {
  const aboutRef = useRef(null);
  const servicesRef = useRef(null);

  const scrollToAbout = () => {
    aboutRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToServices = () => {
    servicesRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const theme = createTheme({
    typography: {
      fontFamily: "'Poppins', sans-serif",
    },
    palette: {
      mode: "light",
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Header
          onAboutClick={scrollToAbout}
          onServicesClick={scrollToServices}
        />
        <HeroSection />
        <div ref={aboutRef}>
          <About />
        </div>
        <Companies />
        <div ref={servicesRef}>
          <Services />
        </div>
        <Contact />
      </Router>
    </ThemeProvider>
  );
}

export default App;
